import { Component, OnInit, HostListener } from '@angular/core';
import { BottomSheet } from '../bottom.sheet';
import { ApiService } from '../api.service';
import { AuthService } from '../auth.service';
import { HandlerService } from '../handler.service';
import { LocationService } from '../location.service';
import { Router } from '@angular/router';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { TranslateService } from '@ngx-translate/core';
import { NativeGeocoderOptions, NativeGeocoder, NativeGeocoderResult } from '@ionic-native/native-geocoder/ngx';
import { Platform } from '@angular/cdk/platform';
import { Geolocation } from '@ionic-native/geolocation/ngx'; 


@Component({
  selector: 'app-customer-subscription-booking',
  templateUrl: './customer-subscription-booking.component.html',
  styleUrls: ['./customer-subscription-booking.component.scss'],
})
export class CustomerSubscriptionBookingComponent {
  brand;
  model;
  type;
  size;
  time;
  cateName;
  apptTime;
  send:boolean=false;
  openItem:boolean=false;
  cateId;
  typeCode;
  category: any = [];
  slots;
  dateFormat;
  minDate = new Date();
  custItem;
  // minDate = new Date();
  categorysearchtypes:any= [];
  purchasedate:any;
  loader: boolean = true;
  active: boolean = true;
  editBool:boolean=false;
  activeInd: boolean = true;  
  item:any;
  fontStyle;
  typeObj;
  id;
  pic;
  cloneUsers:any=[];
  custName;
  itemCategoryObj;
  typeName;
  typeId;
  cost;
  payTotal;
  pageOne;
  pageTwo;
  users:any=[];Name;userId;orgId;
  discountCoupon;
  Oid;Id;
  assign:boolean;
  promotions;
  addItem:boolean=false;
  subsName;
  subsId;
  subsObj;
  totalSubsObj;
  typeObjAll;
  userMobile;
  contactNbrMob;
  custitem;
  custItemName;
  custItemId;
  custitemObj:any=[];
  custResItemObj:any=[];
  total;
  categoryId;
  startdate;
  enddate;
  fdateCheck;
  tdateCheck;
  subsItems;
  subscripId;
  fDate;
  tDate;
  totalItemType:any=[];
  autoGenerate:boolean = false;
  couponId;
  head:boolean=false;
  promoObj:any; 
  buttonObj:any=[{name:"Individual House",flat:false,id:1},
                 {name:"Flat",flat:true,id:2}]
  flatType = this.buttonObj[0].id;
  appt:boolean = this.buttonObj[0].flat;
  flatNo;
  clicked:boolean=false;
  flatName;
  doorNbr;
  street;
  identificationNo;
  colour;
  url;
  custReq:boolean=false;
addBtn:boolean=false;
serReq:boolean=false;
fridgeWashing:boolean=false;
homeCleaning:boolean=false;
acService:boolean=false;
getSubsId;
categoId;
subscriptionId;
cateCode;
carService:boolean=false;
subType;
subItemsType;
itemTypeId;
optionName;
optionId;
pricing:boolean=false;
invoiceId;
capacity;
area;
timeChange:boolean=false;
categoryCode;
info:boolean=false;
  constructor(private service: ApiService,public handler: HandlerService,public router: Router,public translate: TranslateService,
    public auth: AuthService,  public location: LocationService, private bottomSheet: MatBottomSheet,
    private loc: Geolocation,
    private platform:Platform,
    private geoCoder:NativeGeocoder) { }

  ionViewWillEnter() {
    this.getPackage();
    this.categoryCode = sessionStorage.getItem('cateCode') 
    if(this.categoryCode =="PSC" || this.categoryCode =="HC" ||this.categoryCode=="CAR" ){
      this.info=true;
    }
    this.orgId=localStorage.getItem('organizationId')
    this.id = localStorage.getItem('currentUserId');
    this.categoId = sessionStorage.getItem('cateId');
    this.subscriptionId = sessionStorage.getItem('itemId');
    this.location.typeId = sessionStorage.getItem('itemTypeId')
    this.brand = sessionStorage.getItem('make');
    this.location.markedPrice = sessionStorage.getItem('cost')
    this.model = sessionStorage.getItem('model');
    this.dateFormat = this.auth.getDateformat();
    this.pageOne =true;
    this.pageTwo = false;
    this.url=window.location.href     
      this.getCategory();
    this.getitemCategory();     
    this.getPromotions();
    this.itemSubType(); 
       
  }


  getCost(){
    if(this.itemTypeId != undefined && this.location.regionId != undefined &&this.subscriptionId != undefined &&
      this.itemTypeId != "" && this.location.regionId != "" &&this.subscriptionId != ""){
        var data={
          "itemTypeId": this.location.typeId,
          "region": this.location.regionId,
          "serviceId":this.subscriptionId 
        }
        this.service.getCost(data).subscribe((res:any)=>{
          if(res!=null){
            this.location.markedPrice = res[0].cost;
          }else{
            this.handler.error("Please Select Different Location");
            this.location.markedPrice = "";
          }
        }, err => {
          this.handler.err(err);
        })
      }
  }


  blockDate(){
    // Block From Date
    var someDate = new Date();
    var numberOfFromDaysToAdd = 0;
    someDate.setDate(someDate.getDate() + numberOfFromDaysToAdd); 
    var dd = someDate.getDate();
    var mm = someDate.getMonth() + 1;
    var month = mm-1;
    var y = someDate.getFullYear();
    this.fdateCheck = new Date(y, month, dd)
  }
  startDate(){
    this.enddate = "";
    this.fDate=this.returnDate(this.startdate);
  }

  endDate(){
    this.tDate=this.returnDate(this.enddate);
  }
  
  returnDate(data) {
    let date = data.getDate();
    date = date < 10 ? '0' + date : date;
   let month = data.getMonth() + 1;
   month = month < 10 ? '0' + month : month;
   let year = data.getFullYear();
   return year + '-' + month + '-' + date;
 }


  getAppt(id){
    this.appt = id;
  }

  createCustItem() {
    if(this.custItemId){
      this.create();
    }
  else{
    this.loader = true;
    if(!this.brand){
      this.brand="XXX";
    }
    if(!this.model){
      this.model="XXX";
    }
    if(!this.colour){
      this.colour="XXX";
    }
    if(!this.identificationNo){
      this.identificationNo="TN00A0000"
    }
    var post={
      "make": this.brand,
      "model": this.model,
      "type": this.location.typeId,   
      "custName":this.custName,
      "subItemTypeId":this.optionId,
      "capacity":this.capacity,
      "area":this.area,
      "contactNbrMob":this.contactNbrMob,
      "itemCategoryId":this.categoId,
      "userId":this.id,
      "identificationNo":this.identificationNo,
      "activeInd": true,
      "colour":this.colour, 
      "appt":this.appt,
      "houseNbr": this.location.houseNbr,
      "cityId": this.location.cityId,
      "stateId": this.location.stateId,
      "regionId":this.location.regionId,
      "zipcode":this.location.zipcode,
      "lat": this.location.lat,
      "lon": this.location.lon,
    } 
    if(!this.appt){
      Object.assign(post,{"doorNbr":this.doorNbr,"street": this.location.street})
    }else{
      Object.assign(post,{"flatNo":this.flatNo, "flatName":this.flatName,})
    }
    this.service.custItem(post).subscribe(res=>{  
      this.custResItemObj = res; 
      this.custItemId=this.custResItemObj.id; 
      this. create();
      this.loader = false;   
   
    },
    err=>{
      this.loader=false;
      this.handler.err(err);
    })
  }
  
  }
  
 
    create() {
      this.loader = true; 
      if(!this.Id){
        this.payTotal=this.location.markedPrice;
      } 
      var post={
       "custItemId": this.custItemId,
       "providerServiceId":this.subsId,
       "cost" : this.location.markedPrice,
       "discountCoupon": this.Id,
       "payTotal": this.payTotal,
       "subscriptionInd":true,
       "activeInd": true,
       "categoryId": this.categoId,     
       "custName"  :this.custName,
      "contactNbrMob" : this.contactNbrMob,
      "requestorId" : this.id,
      "orgId":localStorage.getItem('organizationId'),
      "apptTime":this.convertTime(this.apptTime), 
      "status":1,
      "startDate":this.fDate,
      "endDate":this.tDate,
      "type":1,     
        "houseNbr": this.location.houseNbr,
        "cityId": this.location.cityId,
        "stateId": this.location.stateId,
        "regionId":this.location.regionId,
        "zipcode":this.location.zipcode,
        "lat": this.location.lat,
        "lon": this.location.lon,   
        "appt":this.appt
      }
      if(!this.appt){
        Object.assign(post,{"doorNbr":this.doorNbr,"street": this.location.street})
      }else{
        Object.assign(post,{"flatNo":this.flatNo, "flatName":this.flatName,})
      }
      this.service.custItemSubscription(post).subscribe((res:any)=>{
        this.invoiceId = res.customerInvoiceId;
        sessionStorage.setItem('requestId', res.id)
        this.handler.res("Subscription Created Successfully");
        this.loader = false;
         this.router.navigate(['invoice/', +this.invoiceId])
   
      },
      err=>{
        this.loader=false;
        this.handler.err(err);
      })
    }

    
    convertTime(tim){
      var time;
      time = tim.split("T");
      time = time[1].split(".");
      time = time[0];
      return time
    }

    cancel(){
      this.router.navigate(['custItem/', + this.id])
    }
    editCustItem() {   
      this.subsItems.custItemId=this.custItemId;
      this.subsItems.providerServiceId=this.subsId;
      this.subsItems.cost=this.location.markedPrice;
      this.subsItems.activeInd = this.activeInd;
      this.subsItems.discountCoupon=this.Id;
      this.subsItems.payTotal=this.payTotal;
      this.subsItems.categoryId =  this.cateId; 
      this.subsItems.custName = this.custName;
      this.subsItems.contactNbrMob =this.contactNbrMob;
      this.subsItems.custUserId=this.id;
      this.subsItems.houseNbr=this.location.houseNbr;
      this.subsItems.street=this.location.street;
      this.subsItems.cityId=this.location.cityId;
      this.subsItems.stateId=this.location.stateId;
      this.subsItems.regionId=this.location.regionId;
      this.subsItems.zipcode=this.location.zipcode;
      this.subsItems.lat=this.location.lat;
      this.subsItems.lon=this.location.lon;
      this.subsItems.appt=this.appt;
      this.subsItems.doorNbr=this.doorNbr;
      this.subsItems.flatName=this.flatName;
      this.subsItems.flatNo=this.flatNo;
      this.subsItems.subscriptionInd=true;
     this.subsItems.startDate=this.fDate;
     this.subsItems.endDate=this.tDate; 
      this.subsItems.orgId=localStorage.getItem('organizationId');
      this.subsItems.status=1;     
      this.service.updateCustItemSubs(this.subscripId,this.subsItems).subscribe(res=>{
        this.handler.res("Subscription Updated Successfully");
        this.loader = false;
        this.router.navigate(['custItem/', + this.id])
  
      },
      err=>{
        this.loader=false;
        this.handler.err(err);
  
      })
    }
  
    next(){
      this.pageOne = false;
      this.pageTwo = true;
      this.payTotal = this.location.markedPrice;
    }

    edit(){
      this.pageOne = false;
      this.pageTwo = true; 
    }

    returnDate1(data) {
      let date = data.getDate();
      date = date < 10 ? '0' + date : date;
      let month = data.getMonth() + 1;
      month = month < 10 ? '0' + month : month;
      let year = data.getFullYear();
      return year + '-' + month + '-' + date;
    }

    popClose(){
      this.location.pop=false;
      this.location.newSearch="";
      this.location.dummy = false;
    }
  
    ionViewWillLeave(){
      this.custItemId = '';
      this.subsId= '';
      this.location.markedPrice= '';     
      this.location.subscriptionId = "";
      this.custItemId = "";
      this.location.pop = false;
      this.location.newSearch="";
      this.location.typeId ="";
      this.Id= '';         
      this.cateId= '';  
      this.custName= '';    
      this.contactNbrMob='';
      this.userId='';
      this.cateName ='';
      this.typeName='';
      this.typeId="";
      this.custName="";  
      this.contactNbrMob='';
      this.custItemName='';  
      sessionStorage.removeItem('cateId')  
      sessionStorage.removeItem('itemType')
      sessionStorage.removeItem('itemId')
    }

    clearTime() {
      this.time = 'Time';
      this.slots = [];
          }

  getCategory(){    
   this.service.getOrgCategory().subscribe((res: any) => {
   this.category=res; 
   if (this.category.length > 0) {
    this.category.map(res1 => {
      if (res1.id == this.categoId ) {         
        this.cateName = res1.name;
        this.cateId = res1.id;
        this.cateCode = res1.code;
        if(this.categoryCode=="CAR"){
          this.carService=true;
        }
        if(this.categoryCode =="PSC" || this.categoryCode =="HC" ){              
          this.pricing=true;
          this.homeCleaning=true;
        }                                               
      }
      }) 
}
   this.getUsers(); 
   }) 
}           

savedItems(){
  this.openItem = true;
  if(this.custitem == ""){
   this.handler.res("No Saved Items For You");
  }
}

  getUsers(){
    this.loader=true;
    this.service.getUserById(this.id).subscribe(res => {
      this.users = res;     
      this.custitemObj=this.users.custItems;  
      this.custitem=this.custitemObj.filter(res =>res.itemCategoryId ==  this.categoId && res.make != "XXX");
      this.custName = this.users.firstName;
      this.contactNbrMob = this.users.contactNbrMob;  
     
        // this.location.regionId=this.users.addresses[0].regionId;
        // this.location.street=this.users.addresses[0].street;
        // this.location.stateId=this.users.addresses[0].stateId;
        // this.location.cityId=this.users.addresses[0].cityId;
        // this.location.zipcode=this.users.addresses[0].zipcode;
        // this.appt=this.users.addresses[0].appt;
        // if(!this.appt){
        //   this.flatType = 1;
        // }else{
        //   this.flatType = 2;
        // }
        // this.doorNbr=this.users.addresses[0].doorNbr;
        // this.flatName=this.users.addresses[0].flatName;
        // this.flatNo=this.users.addresses[0].flatNo;
        this.loader=false;
      })
      this.getCost();
  }

  
  openBottomSheetSubs1(){ 
    if(this.typeId)  { 
      this.subsObj = this.totalSubsObj.filter(res=> res.itemCategoryId == this.cateId );
      const dialogRef = this.bottomSheet.open(BottomSheet,{
      data: this.subsObj,
      });
     dialogRef.afterDismissed().subscribe((res) => {
      if (res) {
      this.subsName = res.name;
       this.subsId = res.id;
       this.couponId = res.discAdId;
       this.location.subscriptionId = res.id;
       if(this.location.typeId != undefined && this.location.regionId != undefined &&this.location.subscriptionId != undefined && 
         this.location.typeId != "" && this.location.regionId != "" &&this.location.subscriptionId != ""){
           var data={
             "itemTypeId": this.location.typeId,
             "region": this.location.regionId,
             "serviceId":this.location.subscriptionId 
           }
           this.service.getCost(data).subscribe((res:any)=>{
             if(res!=null){
               this.location.markedPrice = res[0].cost;
             }else{
               this.handler.error("Please Select Different Location");
               this.location.markedPrice = "";
             }
           }, err => {
             this.handler.err("");

           })       
        }
       }
       });    
      }else{
        this.handler.error("Please Add Your Item");
      }
    }

    openBottomSheetItemType(){
      this.itemCategoryObj = this.totalItemType.filter(res=> this.cateId == res.itemCategory )
        const dialogRef = this.bottomSheet.open(BottomSheet,{
          data: this.itemCategoryObj,
        });
        dialogRef.afterDismissed().subscribe((res:any) => {
          if(res){
            this.typeName = res.name;
            this.typeId=res.id;
            this.location.typeId=res.id;
            if(this.location.typeId != undefined && this.location.regionId != undefined &&this.location.subscriptionId != undefined &&
              this.location.typeId != "" && this.location.regionId != "" &&this.location.subscriptionId != ""){
                var data={
                  "itemTypeId": this.location.typeId,
                  "region": this.location.regionId,
                  "serviceId":this.location.subscriptionId 
                }
                this.service.getCost(data).subscribe((res:any)=>{
                  if(res!=null){
                    this.location.markedPrice = res[0].cost;
                  }else{
                    this.handler.error("Please Select Different Location");
                    this.location.markedPrice = "";
                  }
                }, err => {
                  this.handler.err(err);
                })
            }
          }
           });
   
  }  

  // getUser(val) { 
  //   let x = val.length;
  //   if(x > 0){
  //     this.service.searchCustomers("CUST",val,this.Oid).subscribe((res: any) => {
  //       this.cloneUsers =JSON.parse(JSON.stringify(res)); 
  //     })
  //   }
  //   }

    
    onInput() {
this.location.serviceArea = true;
      this.location.autoComplete();
    }

  
    @HostListener('window:popstate', ['$event'])
    onPopState(event) {   
      this.router.navigate(['/bookservice1'])  
    }

    getPackage(){
      this.service.getAllSubscriptions().subscribe((res:any)=>{
      this.subsObj = res;
      if (this.subsObj.length > 0) {
        this.subsObj.map(res1 => {
          if (res1.id == this.subscriptionId ) {
            this.subsName = res1.name;
            this.subsId = res1.id;
            this.location.subscriptionId = res1.id;
          }
          }) 
    }  
      })
       }

    getitemCategory(){
      this.service.getItemType().subscribe((res:any)=>{
        this.totalItemType = res;
        this.totalItemType.map(res1=>{
          if(res1.id==this.location.typeId){
            this.typeName = res1.name;
            this.typeCode = res1.code;
          }
          if(this.typeCode=="AC"){
            this.fridgeWashing=true;
            this.acService=true;
          }   
          if(this.typeCode=="RF" || this.typeCode=="WM"){
            this.fridgeWashing=true;
          }
          if(this.typeCode=="HO"){
            this.homeCleaning=true;
          } 
        })      
        })
    }

 
  getPromotions(){
    this.service.getServiceCoupon(this.orgId).subscribe(res=>{
      this.promotions = res;
    })
  }
     
       
  openBottomSheetDiscount(): void {
    this.promoObj = this.promotions.filter(res=>{ return res.id == this.couponId});
    const dialogRef = this.bottomSheet.open(BottomSheet,{
      data: this.promoObj,
    });
    dialogRef.afterDismissed().subscribe((res) => {
      this.discountCoupon = res.name;
      this.Id=res.id;
      this.getpayTotal();
    });
  }

      getpayTotal(){
        this.loader = true;
        var post={
          "cost":this.location.markedPrice,
          "discountCoupon":this.discountCoupon
        }
        this.service.getPayTotal(post).subscribe((res:any)=>{
          if(res){      
         this.payTotal = res.payTotal;
         this.send=true;
         this.loader = false;
          }else{
            this.loader=false;
            this.handler.err('Enter Valid Discount Coupen')
          }
        },err =>{
          this.loader = false;
          this.handler.err("err");   
        })
      }



  sendId(data,id){
    data.clicked = ! data.clicked;
    this.custitem.map(res=>{if(id!=res.id){
      res.clicked=false;   
    }
    })
    this.custItemId = id;
    let x=this.custitem.find(res=>res.clicked);
    if(!x){
      this.custItemId ="";
    }
    this.location.typeId = data.type;
    this.location.houseNbr=data.houseNbr;
    this.location.cityId=data.cityId;
    this.location.stateId=data.stateId;
    this.location.street=data.street;
    this.location.regionId=data.regionId;
    this.location.zipcode=data.zipcode;
    this.location.lat=data.lat;
    this.location.lon=data.lon;
    this.appt=data.appt;
    if(!data.appt){
      this.flatType = 1;
    }else{
      this.flatType = 2;
    }
    this.street=data.street;
    this.doorNbr=data.doorNbr;
    this.flatNo=data.flatNo;
    this.flatName=data.flatName;
    this.custReq=true;
    this.serReq=false;
  }


 

  addCustItem(){
    if(this.custitem.length>0){
    this.custitem.map(res=>{
      if(res.clicked){
        res.clicked=false
       }
      })
    }
    this.addItem = true;
    this.custReq=false;
    this.serReq=true;
    this.custItemId = "";
    this.location.regionId=this.users.addresses[0].regionId;
    this.location.street=this.users.addresses[0].street;
    this.location.stateId=this.users.addresses[0].stateId;
    this.location.cityId=this.users.addresses[0].cityId;
    this.location.zipcode=this.users.addresses[0].zipcode;
    this.appt=this.users.addresses[0].appt;
    this.doorNbr=this.users.addresses[0].doorNbr;
    this.flatName=this.users.addresses[0].flatName;
    this.flatNo=this.users.addresses[0].flatNo;
  }

  
  itemSubType(){
    this.service.getSubItemType().subscribe(res=>{
      this.subType=res;
    
    })
  }
  timeValueChange(){
    this.timeChange = true;
  }
  
  openBottomSheetsubType(): void{
    this.subItemsType=this.subType.filter(res=> res.itemTypeId==this.itemTypeId)
   const dialogRef = this.bottomSheet.open(BottomSheet, {
     data:this.subItemsType,
   });
   dialogRef.afterDismissed().subscribe((res) => {
     this.optionName = res.name;
     this.optionId = res.id;
     });
  }

  openLocation(){
    this.location.lat="";
    this.location.lon="";
     this.location.zipcode="";
     this.location.street="";
     this.location.stateId="";
     this.location.cityId="";
     this.location.regionId="";
    this.setLoc();  
    this.location.pop = false;
  }

  setLoc(){
    if(this.platform.ANDROID || this.platform.IOS){
        let options: NativeGeocoderOptions = { useLocale: true,maxResults: 1 };
      this.loc.getCurrentPosition().then(res => {
        this.geoCoder.reverseGeocode(res.coords.latitude, res.coords.longitude, options).then((result: NativeGeocoderResult[]) => {
            let x: any = result;
            localStorage.setItem('location', JSON.stringify(x));
            let loc;
            loc=JSON.parse(localStorage.getItem('location'));
            this.location.lat=loc[0].latitude
            this.location.lon=loc[0].longitude
             this.location.zipcode=loc[0].postalCode
             this.location.street=loc[0].subLocality
             this.location.stateId=loc[0].administrativeArea
             this.location.cityId=loc[0].locality  
             this.location.regionId=loc[0].subLocality;                 
          }, error => {
            if(res){
            this.handler.error('Please enter a address to search')
            }
          });
      },
       error => {
      this.handler.error('Please enter a address to search');
      })
this.location.serviceArea = true;

    }
 }
  
}
